import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const ConfirmInboundDeliveryDateMutation = graphql(/* GraphQL */ `
  mutation confirmInboundDeliveryDate(
    $confirmDateInput: ConfirmInboundDeliveryDateInput!
  ) {
    confirmInboundDeliveryDate(input: $confirmDateInput) {
      inboundDeliveryDetail {
        id
      }
    }
  }
`);
